export const ENTITY_PERMISSIONS = {
  vendor: { entityKey: "vendor", businessEntityKey: "businessVendor" },
  product: { entityKey: "products", businessEntityKey: "businessProducts" },
  fpoMember: { entityKey: "fpoMember" },
  shareCapital: { entityKey: "shareCapital", businessEntityKey: "businessShareCapital" },
  shareTransfer: { entityKey: "shareTransfer", businessEntityKey: "businessShareTransfer" },
  salesOrder: { entityKey: "salesOrder", businessEntityKey: "businessSalesOrder" },
  salesInvoice: { entityKey: "salesInvoice", businessEntityKey: "businessSalesInvoice" },
  salesReturn: { entityKey: "salesReturn", businessEntityKey: "businessSalesReturn" },
  purchaseOrder: { entityKey: "purchaseOrder", businessEntityKey: "businessPurchaseOrder" },
  purchaseInvoice: { entityKey: "purchaseInvoice", businessEntityKey: "businessPurchaseInvoice" },
  purchaseReturn: { entityKey: "purchaseReturn", businessEntityKey: "businessPurchaseReturn" },
  bankRegistry: { entityKey: "bankRegistry", businessEntityKey: "businessBankRegistry" },
  cashbook: { entityKey: "cashbook", businessEntityKey: "businessCashbook" },
  stock: { entityKey: "stock", businessEntityKey: "businessStock" },
  ledger: { entityKey: "ledger", businessEntityKey: "businessLedger" },
  reports: { entityKey: "reports", businessEntityKey: "businessReports" },
  // Distinct from `reports` above — this is My Account/Transactions > Reports specifically
  // (accounts/reports), the top-level Reports page uses `reports`/`businessReports`. Both are
  // real, already-issued permissions (confirmed side-by-side in response.md's accessControls for
  // the same account) — SIDENAV_REDESIGN_PLAN_V2.md §1 gap 4.
  fpoReport: { entityKey: "fpoReport", businessEntityKey: "businessReport" },
  company: { entityKey: "company" },
  membership: { entityKey: "membership" },
  shopCompliance: { entityKey: "shopCompliance" },
  tradeCompliance: { entityKey: "tradeCompliance" },
  gstCompliance: { entityKey: "gstCompliance" },
  fssaiCompliance: { entityKey: "fssaiCompliance" },
  panBusinessCompliance: { entityKey: "panBusinessCompliance" },
  labourCompliance: { entityKey: "labourCompliance" },
  isoCompliance: { entityKey: "isoCompliance" },
  iecCompliance: { entityKey: "iecCompliance" },
  msmeCompliance: { entityKey: "msmeCompliance" },
  fpcCompliance: { entityKey: "fpcCompliance" },
  companyCompliance: { entityKey: "companyCompliance" },
  legalCompliance: { entityKey: "legalCompliance" },
  annualCompliance: { entityKey: "annualCompliance" },
  // Services tab modules -- unlike the compliance entries above, these have a distinct
  // businessEntityKey (mirrors vendor/businessVendor) since they show up under both the FPO
  // Service and MyBusiness Service selectors in /admin/roles, not the shared Compliance tab.
  capacityBuilding: { entityKey: "capacityBuilding", businessEntityKey: "businessCapacityBuilding" },
  businessPlan: { entityKey: "businessPlan", businessEntityKey: "businessBusinessPlan" },
  agmBoard: { entityKey: "agmBoard", businessEntityKey: "businessAgmBoard" },
  fpc: { entityKey: "fpo" },
  role: { entityKey: "roles" },
  users: { entityKey: "users" },
  // Separate from "users" ("User-Edit"/"User-Approve") - see BasePermissions.SUBSCRIPTION_REQUEST
  // for why subscription-request review needed its own permission instead.
  subscriptionRequests: { entityKey: "subscriptionRequests" },
  myFarm: { entityKey: "myFarm" },
  myMarket: { entityKey: "myMarket" },
  myExports: { entityKey: "myExports" },
  myTools: { entityKey: "myTools" },
  myEducation: { entityKey: "myEducation" },
};
